// messageAdapter.ts — converts raw contract messages (ISO timestamps + channel
// enum) into the view model the bubbles render. All formatting happens here so
// the component stays presentation-only and timestamps reflect the user's tz.
import moment from 'moment';
import {
  Channel, TimelineMessage, ThreadMessage,
} from './types';

// Minimal channel labeling, per ticket: only on pet-parent (outgoing) messages.
const CHANNEL_LABELS: Record<Channel, string | undefined> = {
  sms: 'Sent via SMS',
  email: 'Sent via email',
  typeform: 'Sent via survey',
  hub: undefined,
};

/** Day-divider label in the user's local timezone. */
function dayLabel(m: moment.Moment): string {
  if (m.isSame(moment(), 'day')) return 'Today';
  if (m.isSame(moment().subtract(1, 'day'), 'day')) return 'Yesterday';
  return m.format('MMM D, YYYY');
}

/**
 * Map raw timeline messages to view-model messages. `moment(iso)` formats in the
 * browser's local timezone, which is the pet parent's timezone.
 */
export function toThreadMessages(messages: TimelineMessage[]): ThreadMessage[] {
  return messages.map((msg) => {
    const m = moment(msg.sentAt);
    const valid = m.isValid();
    return {
      id: msg.id,
      sender: msg.sender,
      text: msg.text,
      html: msg.html,
      day: valid ? dayLabel(m) : undefined,
      time: valid ? m.format('h:mm a, MMM D') : '',
      channel: msg.sender === 'parent' && msg.channel
        ? CHANNEL_LABELS[msg.channel]
        : undefined,
      media: msg.media,
      survey: msg.survey,
      unread: msg.unread,
    };
  });
}

export default toThreadMessages;
